import React, { Component } from 'react';
import { phoneNumberFormatter } from '../../../../services/common/util';

export default class TextField extends Component {
    handleChange = (e) => {
        let value = e.target.value;
        // Apply phone formatter for tel type
        if (this.props.fieldDef.type === 'tel' && this.props.fieldDef.config && this.props.fieldDef.config.formatPhone) {
            value = phoneNumberFormatter(value);
        }
        this.props.onChange(this.props.fieldDef.fieldId, value);
    };

    render() {
        const { fieldDef, value, hasError, errorMessage, disabled } = this.props;
        const inputType = fieldDef.type === 'tel' ? 'tel' : fieldDef.type === 'number' ? 'number' : fieldDef.type === 'email' ? 'email' : 'text';
        const isRequired = fieldDef.validation && fieldDef.validation.required;

        return (
            <div className="form-group">
                <label>
                    {fieldDef.label}
                    {isRequired && <span className="text-danger"> *</span>}
                </label>
                <input
                    type={inputType}
                    name={fieldDef.fieldId}
                    value={value || ''}
                    onChange={this.handleChange}
                    placeholder={fieldDef.placeholder || ''}
                    disabled={disabled}
                    className={hasError ? 'form-control is-invalid' : 'form-control'}
                />
                <div className={hasError ? 'inline-errormsg' : 'hidden'}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true">
                        &nbsp;{errorMessage || 'This field is required.'}
                    </i>
                </div>
            </div>
        );
    }
}
